import React, { useEffect, useState } from 'react';

const AdSenseAd = ({ 
  adClient = "ca-pub-3914440865956809", 
  adSlot, 
  adFormat = "auto",
  fullWidthResponsive = true,
  style = {},
  className = "",
  placement = "inline", // "sidebar-left", "sidebar-right", "bottom", "inline"
  closeable = false
}) => {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    try {
      // Načítanie AdSense skriptu ak nie je načítaný
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleCloseClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleClose();
  };

  if (!isVisible) return null;

  const getPlacementClass = () => {
    switch (placement) {
      case 'sidebar-left':
        return 'adsense-sidebar-left';
      case 'sidebar-right':
        return 'adsense-sidebar-right';
      case 'bottom':
        return 'adsense-bottom';
      default:
        return 'adsense-container';
    }
  };

  const getAdSize = () => {
    switch (placement) {
      case 'sidebar-left':
      case 'sidebar-right':
        return { width: '160px', height: '600px' };
      case 'bottom':
        // Responsive height for bottom ad
        const isMobile = window.innerWidth <= 768;
        return { 
          width: '100%', 
          height: isMobile ? '60px' : '90px',
          maxHeight: isMobile ? '60px' : '90px'
        };
      default:
        return style;
    }
  };

  return (
    <div className={`${getPlacementClass()} ${className}`} style={style}>
      {closeable && placement === 'bottom' && (
        <button 
          className="close-ad" 
          onClick={handleCloseClick}
          onTouchStart={handleCloseClick}
          aria-label="Zavrieť reklamu"
          type="button"
        >
          ×
        </button>
      )}
      <ins 
        className="adsbygoogle"
        style={{ 
          display: 'block', 
          ...getAdSize()
        }}
        data-ad-client={adClient}
        data-ad-slot={adSlot}
        data-ad-format={placement === 'sidebar-left' || placement === 'sidebar-right' ? 'vertical' : adFormat}
        data-full-width-responsive={placement === 'bottom' ? true : fullWidthResponsive}
      ></ins>
    </div>
  );
};

export default AdSenseAd;
